var _g, _rect, _mask, _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgProfileBtn = function SvgProfileBtn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 90 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#profile-btn_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.6 23c22.3-4.8 65-4 56.8 37.8C64.3 113-18.6 40 17.6 23z",
    fill: "url(#profile-btn_svg__b)"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 37.9,
    y: 36.1,
    width: 13.9,
    height: 13.9,
    rx: 7,
    stroke: "currentColor",
    strokeWidth: 2
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "profile-btn_svg__c",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.8 50.6c-1.2 1.3-2 3-2 5 0 .7.7 1.3 1.5 1.3h13.2c.7 0 1.4-.6 1.4-1.4 0-1.9-.8-3.6-2-4.9a6 6 0 0 1-1.7 1.1c.9.8 1.5 2 1.7 3.2h-12c.2-1.2.8-2.4 1.7-3.2a6 6 0 0 1-1.8-1.1z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.8 50.6c-1.2 1.3-2 3-2 5 0 .7.7 1.3 1.5 1.3h13.2c.7 0 1.4-.6 1.4-1.4 0-1.9-.8-3.6-2-4.9a6 6 0 0 1-1.7 1.1c.9.8 1.5 2 1.7 3.2h-12c.2-1.2.8-2.4 1.7-3.2a6 6 0 0 1-1.8-1.1z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m38.8 50.6 1.4-1.5-1.5-1.3-1.3 1.4 1.4 1.4zm12.1 0 1.5-1.4-1.4-1.4-1.4 1.3 1.3 1.5zm-1.7 1.1-.8-1.8-2.9 1.2 2.3 2 1.4-1.4zm1.7 3.2v2H53l-.3-2.2-2 .2zm-12 0-2-.2-.2 2.2h2.2v-2zm1.7-3.2 1.3 1.5 2.4-2.1-3-1.2-.7 1.8zm-3.2-2.5a9.1 9.1 0 0 0-2.5 6.3h4c0-1.4.5-2.6 1.4-3.5l-3-2.8zm-2.5 6.3c0 1.9 1.5 3.4 3.4 3.4v-4c.3 0 .6.3.6.6h-4zm3.4 3.4h13.2v-4H38.3v4zm13.2 0c1.8 0 3.4-1.5 3.4-3.4h-4c0-.3.2-.6.6-.6v4zm3.4-3.4c0-2.4-1-4.6-2.5-6.3l-3 2.8c1 .9 1.5 2.1 1.5 3.5h4zm-5.3-6.4a4 4 0 0 1-1.2.8l1.6 3.7a8 8 0 0 0 2.3-1.5l-2.7-3zm3.2 5.6c-.2-1.8-1-3.3-2.3-4.5l-2.7 3c.6.5 1 1.2 1 2l4-.5zM39 57h12v-4H39v4zm.3-6.7a7.1 7.1 0 0 0-2.3 4.5l4 .5c0-.8.5-1.5 1-2l-2.7-3zm2.1-.3a4 4 0 0 1-1.1-.8l-2.7 3a8 8 0 0 0 2.3 1.5l1.5-3.7z",
    fill: "currentColor",
    mask: "url(#profile-btn_svg__c)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "profile-btn_svg__b",
    x1: 17,
    y1: 52.1,
    x2: 78.4,
    y2: 91.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#67BFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#92FBF4"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "profile-btn_svg__a",
    x: 4.5,
    y: 21,
    width: 75,
    height: 66.3,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0.917647 0 0 0 0 0.972549 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
};
export default SvgProfileBtn;